export function ReportsLeftSkeleton() {
  return (
    <>
      <div className="rp__left__label">Reports</div>
      <div className="rp__left__stats rp__shimmer-block">
        <div className="rp__left__stats__count">
          <span className="rp__shimmer rp__shimmer--text rp__shimmer--sm" />
          <span className="rp__shimmer rp__shimmer--text rp__shimmer--xs" />
        </div>
        <div className="rp__left__stats__badges">
          <span className="rp__shimmer rp__shimmer--pill" />
          <span className="rp__shimmer rp__shimmer--pill" />
        </div>
      </div>
      <div className="rp__left__tabs rp__left__tabs--skeleton">
        <span className="rp__shimmer rp__shimmer--tab" />
        <span className="rp__shimmer rp__shimmer--tab" />
      </div>
      <div className="rp__left__list">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={`left-skeleton-${index}`} className="rp__left-card rp__left-card--skeleton">
            <div className="rp__left-card__header">
              <div className="rp__left-card__main">
                <span className="rp__shimmer rp__shimmer--icon" />
                <span className="rp__shimmer rp__shimmer--text" />
              </div>
              <span className="rp__shimmer rp__shimmer--meta" />
            </div>
            <div className="rp__left-card__tags">
              <span className="rp__shimmer rp__shimmer--tag" />
              <span className="rp__shimmer rp__shimmer--tag" />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export function ReportsRightBodySkeleton() {
  return (
    <div className="rp__scroll-shell rp__scroll-shell--skeleton">
      <div className="rp__scroll rp__scroll--skeleton">
        {Array.from({ length: 8 }).map((_, index) => (
          <div key={`right-skeleton-${index}`} className="rp__row rp__row--skeleton">
            <span className="rp__shimmer rp__shimmer--row-icon" />
            <span className="rp__shimmer rp__shimmer--row-time" />
            <span className="rp__shimmer rp__shimmer--row-flex" />
            <span className="rp__shimmer rp__shimmer--row-flex" />
            <span className="rp__shimmer rp__shimmer--row-id" />
            <span className="rp__shimmer rp__shimmer--row-result" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function ReportsRightSkeleton() {
  return (
    <>
      <div className="rp__right__header rp__right__header--skeleton">
        <span className="rp__shimmer rp__shimmer--header" />
        <div className="rp__right__header__actions">
          <span className="rp__shimmer rp__shimmer--button" />
          <span className="rp__shimmer rp__shimmer--button" />
        </div>
      </div>
      <ReportsRightBodySkeleton />
    </>
  );
}
